import React from "react";
import UserCourseView from "views/Teams/UserCourses/UserCourseView";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faCheckCircle, faComments, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const GrowthPartnerCourseView = (props) => {
  // Custom component to replace the growth partner section
  const GrowthPartnerGuidance = () => (
    <Card className="mb-4">
      <Card.Body>
        <h5 className="mb-3">Growth Partner Guide</h5>
        <p className="text-muted mb-3">
          As a growth partner, you can review this course and provide valuable feedback:
        </p>
        <div className="mb-3">
          <div className="mb-2">
            <FontAwesomeIcon icon={faEdit} className="me-2 text-primary" />
            Review lessons marked for review
          </div>
          <div className="mb-2">
            <FontAwesomeIcon icon={faCheckCircle} className="me-2 text-success" />
            Set SIA status (green/yellow/red)
          </div>
          <div className="mb-2">
            <FontAwesomeIcon icon={faComments} className="me-2 text-info" />
            Provide feedback comments
          </div>
        </div>
        
        <div className="alert alert-info mt-3">
          <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
          <strong>Look for the "Review Required" badge</strong> on lessons that need your feedback. Once reviewed, the badge will change to <strong>"Reviewed"</strong> in green. You can provide your review even if the learner hasn't completed the lesson yet.
        </div>
        
        <p className="mb-0">
          Navigate through modules and lessons to find review sections where you can provide feedback.
        </p>
      </Card.Body>
    </Card>
  );

  return (
    <UserCourseView 
      {...props} 
      isGrowthPartnerView={true} 
      hideProgress={true}
      hideCompletionStatus={true}
      hideModuleList={true}
      customGrowthPartnerSection={<GrowthPartnerGuidance />}
    />
  );
};

export default GrowthPartnerCourseView; 